import type { SVGProps } from "react";
export interface EyeOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function EyeOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: EyeOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M11.997 2.875c3.49 0 6.039 1.56 7.787 3.334 1.73 1.757 2.708 3.75 3.129 4.749a2.67 2.67 0 0 1 0 2.083 16 16 0 0 1-1.352 2.533l-.069.094a1.125 1.125 0 0 1-1.813-1.328l.394-.637c.357-.617.61-1.16.767-1.535a.42.42 0 0 0 0-.335c-.364-.865-1.207-2.57-2.66-4.045-1.435-1.457-3.436-2.663-6.183-2.663-.671 0-1.293.072-1.87.2a1.125 1.125 0 0 1-.483-2.198c.736-.162 1.52-.252 2.353-.252m-9.793-.67a1.126 1.126 0 0 1 1.506-.078l.085.078 18 18 .078.085a1.125 1.125 0 0 1-1.584 1.583l-.085-.078-2.387-2.387c-1.546 1.009-3.473 1.716-5.82 1.716-3.49 0-6.037-1.56-7.784-3.335-1.73-1.758-2.708-3.75-3.128-4.749a2.67 2.67 0 0 1 0-2.08c.432-1.027 1.469-3.14 3.333-4.951L2.204 3.795l-.077-.085a1.126 1.126 0 0 1 .077-1.505M6.008 7.6c-1.563 1.509-2.465 3.32-2.849 4.233a.42.42 0 0 0 0 .334c.364.864 1.205 2.57 2.656 4.044 1.434 1.457 3.434 2.663 6.182 2.664 1.658 0 3.037-.44 4.185-1.102l-1.443-1.443a5.125 5.125 0 0 1-7.07-7.07zM9.126 12a2.875 2.875 0 0 0 3.949 2.666l-3.741-3.741A2.9 2.9 0 0 0 9.126 12"
      />
    </svg>
  );
}
